import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 28px;
  background: rgba(255, 250, 246, 0.9);
  border-bottom: 1px solid rgba(224, 207, 198, 0.86);
  backdrop-filter: blur(16px);

  @media (max-width: 720px) {
    align-items: flex-start;
    flex-direction: column;
    padding: 12px 18px;
  }
`;

const Brand = styled(Link)`
  color: #4a3833;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 22px;
  font-weight: 400;
  text-decoration: none;

  &:before {
    content: '♡';
    display: block;
    color: #d48b8f;
    font-family: Quicksand, sans-serif;
    font-size: 16px;
    line-height: 1;
    text-align: center;
  }
`;

const Navigation = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;

  a {
    color: #5d4b45;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;

    &:hover {
      color: #c9858a;
    }
  }
`;

const LocationPlatformHeader = () => (
  <Header>
    <Brand to="/hochzeitslocations/">EureHochzeitOnline</Brand>
    <Navigation aria-label="Location Navigation">
      <Link to="/hochzeitslocations/">Locations</Link>
      <Link to="/hochzeitslocations/muenchen/">München</Link>
      <Link to="/hochzeitslocations/berlin/">Berlin</Link>
      <Link to="/hochzeitslocations/hamburg/">Hamburg</Link>
      <Link to="/hochzeit-erstellen/">Hochzeitsseite erstellen</Link>
    </Navigation>
  </Header>
);

export default LocationPlatformHeader;
